// extracted by mini-css-extract-plugin
export default {"addItem":"addJobForm_addItem__Rdm6z","formItem":"addJobForm_formItem__kVxW4","icon":"addJobForm_icon__epymL","input":"addJobForm_input__T5cD7","saveBtn":"addJobForm_saveBtn__On7sx"};